import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Children } from 'react'

import { Title } from './title'
import { Layout } from './layout'
import { Top } from './top'
import { Content } from './content'
import { Sidebar } from './sidebar'
import { Bottom } from './bottom'
import { Columns } from './columns'
import { ColumnLeft } from './columnLeft'
import { ColumnRight } from './columnRight'

const getTemplateAreas = ({ hasTitle }) => {
  if (hasTitle) {
    return `
      "${Title.area}"
      "${Layout.area}"
    `
  }

  return `
    "${Layout.area}"
  `
}
const Grid = styled.div`
  display: grid;
  row-gap: ${({ hasTitle }) => (hasTitle ? '40px' : 0)};
  grid-template-columns: 100%;
  grid-auto-rows: auto;
  grid-template-areas: ${getTemplateAreas};
  background-color: ${({ bgColor }) => bgColor};
`
const Page = ({ children, bgColor = 'white', ...rest }) => {
  const hasTitle = Children.toArray(children).some(
    child => child.type.slotName === Title.slotName
  )

  return (
    <Grid hasTitle={hasTitle} bgColor={bgColor} {...rest}>
      {children}
    </Grid>
  )
}

Page.propTypes = {
  bgColor: PropTypes.string,
  /** @ignore Storybook control */
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([Layout])
    }),
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          type: PropTypes.oneOf([Title])
        }),
        PropTypes.shape({
          type: PropTypes.oneOf([Layout])
        })
      ])
    )
  ]).isRequired
}

Page.Title = Title
Page.Layout = Layout
Page.Top = Top
Page.Content = Content
Page.Sidebar = Sidebar
Page.Bottom = Bottom
Page.Columns = Columns
Page.ColumnLeft = ColumnLeft
Page.ColumnRight = ColumnRight

export { Page }
export { gap } from './defaults'
